import React, { useCallback, useEffect } from "react";
import Draggable, { DraggableCore } from "react-draggable";

import style from "./Hub.module.scss";

import { View } from "../storage/routes";
import { useLocation } from "react-router-dom";
import { MODAL_CLOSE_TYPE, displayModal, hideModal } from '../storage/emitter'
import WidgetLayout from "../Components/Widgets/WidgetLayout";

const Hub = () => {
  const { pathname } = useLocation();

  const checkModal = useCallback(() => {
    if (pathname !== "/") {
      displayModal("demo", MODAL_CLOSE_TYPE.BACK);
    } else {
      hideModal("demo");
    }
  }, []);

  useEffect(() => {
    checkModal();
  }, [pathname, checkModal]);
  useEffect(() => {
    checkModal();
  }, []);

  return (
    <View style={{ height: "93%" }}>
      <div id={style.hub}>
        <WidgetLayout />
      </div>
    </View>
  );
};

export default Hub;
